import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Grid, Typography, Card, CardContent, CardMedia, Button, Box, Container, CircularProgress } from "@mui/material";

const backendUrl = window.location.hostname === "localhost"
  ? "http://localhost:5001"
  : "https://own-project.onrender.com";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

const fetchProducts = async () => {
  try {
    const response = await axios.get(`${backendUrl}/api/printful-products`);
    console.log(response.data); 
    setProducts(response.data.result || []);
  } catch (err) {
    console.error("❌ Error fetching products:", err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => { fetchProducts(); }, []);

  return (
    <Container maxWidth="xl" sx={{ minHeight: 'calc(100vh - 80px)', paddingBottom: '80px' }}>
      <Box sx={{ paddingY: 2, textAlign: "center" }}>
        <Typography variant="subtitle1" fontWeight="bold">
          Leveranstid: 5–13 arbetsdagar
        </Typography>
      </Box>

      <Box sx={{ padding: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>Produkter</Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>
        ) : products.length === 0 ? (
          <Typography variant="body1" align="center" color="text.secondary">Inga produkter tillgängliga.</Typography>
        ) : (
          <Grid container spacing={3}>
            {products.map((product) => (
              <Grid item xs={12} sm={6} md={3} key={product.id}>
                <Card sx={{ borderRadius: 3, boxShadow: "0 4px 15px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", height: "100%" }}>
                  <CardMedia component="img" alt={product.name} image={product.thumbnail_url || "/placeholder.jpg"} sx={{ height: 300, objectFit: "contain", padding: 2 }} />
                  <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <Typography variant="h6" noWrap>{product.name}</Typography>
                    <Typography variant="subtitle1" color="primary">Pris: {product.price_with_vat ? Math.round(product.price_with_vat) : "Ej angivet"} kr</Typography>
 <Button
  component={Link}
  to={`/design/${product.id}`}
  fullWidth
  sx={{
    mt: 2,
    fontWeight: "bold",
    fontSize: "1rem",
    borderRadius: 2,
    paddingY: 1.2,
    background: "linear-gradient(90deg, #1e3a8a, #3b82f6)", // djupblå → klarblå
    color: "#fff",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    textTransform: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(90deg, #3b82f6, #1e3a8a)", // inverterad på hover
      boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "translateY(0px)",
      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    },
  }}
>
  Visa produkt
</Button>

                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default ProductList;
